module.exports = __webpack_public_path__ + "static/media/matilde-thinking.8256ead4.png";